import { createContext, useContext, useEffect } from 'react';

export const PageTitleContext = createContext({
  setPageTitle: () => {}
});

/** Override the layout header title while this component is mounted. */
export function usePageTitle(title) {
  const { setPageTitle } = useContext(PageTitleContext);
  useEffect(() => {
    setPageTitle(title || '');
    return () => setPageTitle('');
  }, [title, setPageTitle]);
}
